import { ChucksOtherTestTable } from './Tables/ChuckOtherTest.Table'
import { ChucksTestTable } from './Tables/ChuckTest.Table'
import { ShoppingFunnel00Table } from './Tables/ShoppingFunnel00.Table'
import { PayBill00Table } from './Tables/PayBill00.Table'
import { CTA00Table } from './Tables/CTA00.Table'
import { GettingStartedMenu00Table } from './Tables/GettingStartedMenu00.Table'
import { Feedback00Table } from './Tables/Feedback00.Table'
import { MyStorage00Table } from './Tables/MyStorage00.Table'
import { ProfileCollect00Table } from './Tables/ProfileCollect00.Table'
import { PersonaCollect00Table } from './Tables/PersonaCollect00.Table'
import { FMS00Table } from './Tables/FMS00.Table'
import { Discounts00Table } from './Tables/Discounts00.Table'
import { FMSPlusMoveIn00Table } from './Tables/FMSPlusMoveIn00.Table'
import { FMSPlusMoveOut00Table } from './Tables/FMSPlusMoveOut00.Table'
import { FMSPlusPastDue00Table } from './Tables/FMSPlusPastDue00.Table'
import { FMSPlusPaymentMethodExpiring00Table } from './Tables/FMSPlusPaymentMethodExpiring00.Table'
import { FMSPlusPaymentSuccess00Table } from './Tables/FMSPlusPaymentSuccess00.Table'
import { FMSPlusUpcomingPayment00Table } from './Tables/FMSPlusUpcomingPayment00.Table'
import { FMSPlusUpdateContactInfo00Table } from './Tables/FMSPlusUpdateContactInfo00.Table'
import { GateCode00Table } from './Tables/GateCode00.Table'
import { GoogleChatLinks00Table } from './Tables/GoogleChatLinks00.Table'
import { SizeDescriptions00Table } from './Tables/SizeDescriptions00.Table'
import { GMBSessionTable } from './Tables/GMBSession.Table'
import { EnumHelpers } from '../helpers/Enum.Helpers'
import { SMSLinks00Table } from './Tables/SMSLinks00.Table'
import { UnitNumber00Table } from './Tables/UnitNumber00.Table'
import { FMSPlusAbandonedCarts00Table } from './Tables/FMSPlusAbandonedCarts00.Table'
import { UnhandledsDuringProfileCollect00Table } from './Tables/UnhandledsDuringProfileCollect'
import { AccountBalance00Table } from './Tables/AccountBalance00.Table'
import { MyStorage01Table } from './Tables/MyStorage01.Table'

export const AllTables = {
  [ShoppingFunnel00Table.id]: ShoppingFunnel00Table,
  [ProfileCollect00Table.id]: ProfileCollect00Table,
  [PayBill00Table.id]: PayBill00Table,
  [GettingStartedMenu00Table.id]: GettingStartedMenu00Table,
  [Feedback00Table.id]: Feedback00Table,
  [CTA00Table.id]: CTA00Table,
  [PersonaCollect00Table.id]: PersonaCollect00Table,
  [MyStorage00Table.id]: MyStorage00Table,
  [FMS00Table.id]: FMS00Table,
  [Discounts00Table.id]: Discounts00Table,
  [FMSPlusMoveIn00Table.id]: FMSPlusMoveIn00Table,
  [FMSPlusMoveOut00Table.id]: FMSPlusMoveOut00Table,
  [FMSPlusPastDue00Table.id]: FMSPlusPastDue00Table,
  [FMSPlusPaymentMethodExpiring00Table.id]: FMSPlusPaymentMethodExpiring00Table,
  [FMSPlusPaymentSuccess00Table.id]: FMSPlusPaymentSuccess00Table,
  [FMSPlusUpcomingPayment00Table.id]: FMSPlusUpcomingPayment00Table,
  [FMSPlusUpdateContactInfo00Table.id]: FMSPlusUpdateContactInfo00Table,
  [GateCode00Table.id]: GateCode00Table,
  [GoogleChatLinks00Table.id]: GoogleChatLinks00Table,
  [SizeDescriptions00Table.id]: SizeDescriptions00Table,
  [SMSLinks00Table.id]: SMSLinks00Table,
  [UnitNumber00Table.id]: UnitNumber00Table,
  [FMSPlusAbandonedCarts00Table.id]: FMSPlusAbandonedCarts00Table,
  [UnhandledsDuringProfileCollect00Table.id]: UnhandledsDuringProfileCollect00Table,
  [AccountBalance00Table.id]: AccountBalance00Table,
  [MyStorage01Table.id]: MyStorage01Table
  // [ChucksTestTable.id]: ChucksTestTable,
  // [ChucksOtherTestTable.id]: ChucksOtherTestTable,
  // [GMBSessionTable.id]: GMBSessionTable  // I am removing this since we dont need to see them in the lists
}
